import * as React from "react";
import {
    Button,
    Dialog,
    DialogTrigger,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogContent,
} from "@fluentui/react-components";

const OutlookDialog = ({open,onOpenChange,trigger,title,content,action,actionButtonText,actionButton}) => {

    return (
        <Dialog
            open={open}
            onOpenChange={onOpenChange}
        >
            <DialogTrigger disableButtonEnhancement>
                {trigger}
            </DialogTrigger>
            <DialogSurface>
                <DialogBody>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {content}
                </DialogContent>
                {action && <DialogActions>
                    {actionButton}
                    <DialogTrigger disableButtonEnhancement>
                    <Button appearance="secondary">Close</Button>
                    </DialogTrigger>
                </DialogActions>}
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}

export default OutlookDialog;